/* L'OREMONT PARIS — globale Basis (Nav) für Cart/Pages/404 */
(function () {
  /* ---------- Nav: solide + Scroll-Schatten ---------- */
  (function nav() {
    const nav = document.getElementById('nav');
    const onScroll = () => nav.classList.toggle('is-scrolled', window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

    const toggle = document.getElementById('nav-toggle');
    const panel = document.getElementById('nav-panel');
    if (!toggle || !panel) return;
    const links = panel.querySelectorAll('a');
    let open = false;
    function setOpen(next) {
      open = next;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
      panel.hidden = false;
      requestAnimationFrame(() => panel.classList.toggle('is-open', open));
      document.body.style.overflow = open ? 'hidden' : '';
      if (!open) setTimeout(() => { panel.hidden = true; }, 500);
    }
    toggle.addEventListener('click', () => setOpen(!open));
    links.forEach((a) => a.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && open) setOpen(false); });
  })();

})();
